<button mat-icon-button (click)="goToSettings()">
  <mat-icon [svgIcon]="'heroicons_outline:cog'"></mat-icon>
</button>
